// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"904":"e92720a2","935":"9cd3738d","954":"ebce959c"}[chunkId] + ".chunk.css";
};